import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { ProductsAPI } from '../services/api';
import { useCart } from '../contexts/CartContext';

const ProductList = () => {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const { dispatch } = useCart();

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        setLoading(true);
        const response = await ProductsAPI.getProducts(page);
        setProducts(response.products);
        setTotalPages(response.totalPages);
        setLoading(false);
      } catch (err) {
        setError('Неуспешно зареждане на продукти. Моля, опитайте отново по-късно.');
        setLoading(false);
      }
    };

    fetchProducts();
  }, [page]);

  const handleAddToCart = (product) => {
    dispatch({
      type: 'ADD_ITEM',
      payload: {
        id: product.id,
        name: product.name,
        price: parseFloat(product.price),
        image: product.images && product.images.length > 0 ? product.images[0].src : '',
        quantity: 1
      }
    });
  };

  const handlePreviousPage = () => {
    setPage((prevPage) => Math.max(prevPage - 1, 1));
  };

  const handleNextPage = () => {
    setPage((prevPage) => Math.min(prevPage + 1, totalPages));
  };

  if (loading) return <div className="text-center py-10 text-lg">Зареждане на продукти...</div>;
  if (error) return <div className="text-center py-10 text-lg text-red-600">{error}</div>;

  return (
    <div className="max-w-7xl mx-auto px-5 py-5">
      <h2 className="text-2xl font-bold mb-5">Нашите продукти</h2>
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-5 mt-5">
        {products.map((product) => (
          <div key={product.id} className="border border-gray-200 rounded-lg overflow-hidden transition-transform duration-300 hover:-translate-y-1 hover:shadow-lg">
            <div className="h-[200px] overflow-hidden flex items-center justify-center bg-gray-50">
              {product.images && product.images.length > 0 ? (
                <img src={product.images[0].src} alt={product.name} className="w-full h-full object-cover" />
              ) : (
                <div className="text-gray-500 text-sm">Няма изображение</div>
              )}
            </div>
            <div className="p-4">
              <h3 className="m-0 mb-2.5 text-lg">
                <Link to={`/product/${product.id}`} className="text-gray-800 no-underline hover:text-primary">
                  {product.name}
                </Link>
              </h3>
              <div className="text-lg font-bold text-gray-800 mb-2.5">
                {parseFloat(product.price).toFixed(2)} лв
              </div>
              <div className="mb-4 text-sm">
                {product.stock_status === 'instock' ? (
                  <span className="text-green-600">В наличност</span>
                ) : (
                  <span className="text-red-600">Изчерпан</span>
                )}
              </div>
              <button
                className={`w-full py-2.5 px-0 rounded text-white text-base transition-colors ${
                  product.stock_status === 'instock'
                    ? 'bg-primary hover:bg-primary/80'
                    : 'bg-gray-400 cursor-not-allowed'
                }`}
                onClick={() => handleAddToCart(product)}
                disabled={product.stock_status !== 'instock'}
              >
                Добави в кошницата
              </button>
            </div>
          </div>
        ))}
      </div>
      <div className="flex justify-center items-center mt-8">
        <button 
          onClick={handlePreviousPage} 
          disabled={page === 1}
          className={`py-2 px-4 mx-2.5 rounded text-white ${
            page === 1 ? 'bg-gray-400 cursor-not-allowed' : 'bg-primary hover:bg-primary/80'
          }`}
        >
          Предишна
        </button>
        <span className="mx-2.5">
          Страница {page} от {totalPages}
        </span>
        <button 
          onClick={handleNextPage} 
          disabled={page === totalPages}
          className={`py-2 px-4 mx-2.5 rounded text-white ${
            page === totalPages ? 'bg-gray-400 cursor-not-allowed' : 'bg-primary hover:bg-primary/80'
          }`}
        >
          Следваща
        </button>
      </div>
    </div>
  );
};

export default ProductList; 